import Vue from "vue";
import VueI18n from "vue-i18n";
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';



Vue.use(VueI18n); // 全局挂载
Vue.locale = () => {};

   

export const i18n = new VueI18n({
  legacy: false,
  globalInjection: true, // 全局注册$t方法
  locale: 'zh-CN',
  messages: {
    'zh-CN':  Object.assign(require("./lan/zh"), zh), // 中文语言包
    'en-US': Object.assign(require("./lan/en"), en), // 英文语言包
  }
});
export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js